// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609101240/js/" + chunkId + "." + {"44":"beca1d70","225":"546ad6a4","481":"fa7e8fda","486":"6b807b5a","770":"aa0d85ea"}[chunkId] + ".0.9477089157798697.chunk.js";
};